import React from 'react';
import Chart from 'react-apexcharts';
import GraphLoader from './GraphLoader';

const BarChartComponent = ({ data }) => {
    const loading = !data?.length;
    if (loading) {
        return <GraphLoader />;
    }
    const options = {
        chart: {
            type: 'bar',
            height: 364,
            toolbar: { show: true },
            animations: { enabled: false },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '40%',
                distributed: true,
            },
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: data.map((d) => d.name), // station + assetType
        },
        yaxis: {
            title: { text: 'Total Count' },
        },

        legend: { show: false },
    };
    const series = [
        {
            name: 'Total',
            data: data.map((d) => d.total),
        },
    ];
    return <Chart options={options} series={series} type="bar" height={378} />;
};

export default BarChartComponent;
